// extracted by mini-css-extract-plugin
module.exports = {"backButton":"TwoColTemplate_backButton__gFyvZ"};